import React from "react"
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Button
} from "reactstrap"
import moment from "moment"
import Select from "react-select"
import styled from "styled-components"

const QueryPanel = ({
  columnDefs,
  setValue,
  onQuery,
  onClear,
  options,
  isQuery,
  isBalanceAmountPaid,
  isDefaultValue,
  variables
}) => {
  const convertOptionsPlaceHolder = (title, name, value, options) => {
    const defaultValue = options?.find(
      (item) =>
        item.value === variables?.find((item) => item?.name === name)?.value
    )?.label

    if (value) {
      return value
    }

    if (isQuery) {
      return defaultValue
    }

    return title
  }

  const convertDatePlaceHolder = (value, name) => {
    const defaultValue = variables?.find((item) => item?.name === name)?.value

    if (value) {
      return value || ""
    }

    if (isQuery) {
      return moment(defaultValue).format("YYYY/MM/DD")
    }

    return value || ""
  }

  const convertInputPlaceHolder = (value, name) => {
    const defaultValue = variables?.find((item) => item?.name === name)?.value

    if (value) {
      return value || ""
    }

    if (isQuery) {
      return defaultValue
    }

    return value || ""
  }

  const convertOptions = (opts) => {
    return (
      opts?.map((o) => ({
        label: o.value,
        value: o.key
      })) || []
    )
  }

  const bindSelectedValue = (value, options) => {
    if (!value) {
      return null
    }

    return options?.find((o) => o.value === value || o.id === value)
  }

  const renderQueryField = (col, key) => {
    switch (col.type) {
      case "input":
        return (
          <InputGroup key={key} data-variable-name={col.name}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>{col.title}</InputGroupText>
            </InputGroupAddon>
            <Input
              style={{ height: "100%" }}
              value={convertInputPlaceHolder(col.value, col.name)}
              onChange={(e) => setValue(col.name, e.target.value)}
            />
          </InputGroup>
        )
      case "input-number":
        return (
          <InputGroup key={key} data-variable-name={col.name}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>{col.title}</InputGroupText>
            </InputGroupAddon>
            <Input
              type="number"
              style={{ height: "100%" }}
              value={convertInputPlaceHolder(col.value, col.name)}
              onChange={(e) => setValue(col.name, Number(e.target.value))}
            />
          </InputGroup>
        )
      case "date":
        return (
          <InputGroup key={key} data-variable-name={col.name}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>{col.title}</InputGroupText>
            </InputGroupAddon>
            <Input
              style={{ height: "100%" }}
              type="date"
              max={"9999-12-31"}
              value={convertDatePlaceHolder(col.value, col.name)}
              onChange={(e) => setValue(col.name, e.target.value)}
            />
          </InputGroup>
        )
      case "select":
        return (
          <SelectContainer
            data-component-name="FormSelectGroup"
            key={col.title}
          >
            <InputGroupAddon addonType="prepend">
              <InputGroupText>{col.title}</InputGroupText>
            </InputGroupAddon>
            <div style={{ flex: 1 }}>
              <Select
                value={bindSelectedValue(col.value, col.options)}
                key={col.name}
                name={col.title}
                placeholder={convertOptionsPlaceHolder(
                  col.title,
                  col.name,
                  col.value,
                  col.options
                )}
                options={convertOptions(col.options)}
                onChange={(e) => {
                  if (Array.isArray(e) && e.length === 0) {
                    setValue(col.name, undefined)
                    return
                  }

                  if (Array.isArray(e)) {
                    setValue(col.name, e)
                    return
                  }

                  e?.value || e?.id
                    ? setValue(col.name, e?.value || e?.id)
                    : setValue(col.name, undefined)
                }}
              />
            </div>
          </SelectContainer>
        )
      default:
        return null
    }
  }

  return (
    <div className="mb-2">
      <GridBox data-component-name="GridBox">
        {columnDefs?.map((col, key) => renderQueryField(col, key))}
      </GridBox>
      <Button
        onClick={onQuery}
        style={{
          background: "#1e88e5",
          color: "#fff",
          borderColor: "transparent"
        }}
      >
        查詢
      </Button>
      <Button
        onClick={onClear}
        style={{
          marginLeft: 10,
          background: "#BCBCBC",
          color: "#fff",
          borderColor: "transparent"
        }}
      >
        清除
      </Button>
    </div>
  )
}

const GridBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-bottom: 10px;
`

const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
`
export default QueryPanel
